/**
 * @file product
 * @author wangzhuang
 */

import {
    GET_PAGES_DATABYID,
    GET_SERVICE_INTRODUCE,
    POST_PRODUCT_ID,
    GET_SCAN_SERVERVICE,
    FETCH_CHACK_AI_IMAGE,
    FETCH_CHACK_AI_INSDUSTRY
} from '../actions/ActionTypes';

export function pagesDatabyid(state = {}, action) {
    switch (action.type) {
        case GET_PAGES_DATABYID:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function serviceIntroduce(state = {}, action) {
    switch (action.type) {
        case GET_SERVICE_INTRODUCE:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function productId(state = {}, action) {
    switch (action.type) {
        case POST_PRODUCT_ID:
            state = action.data;
            return action.data;
        default:
            return state;
    }
}

export function scanServices(state = {}, action) {
    switch (action.type) {
        case GET_SCAN_SERVERVICE:
            state = action.data;
            return action.data;
        default:
            return state;
    }
}

export function checkAiImageData(state = {}, action) {
    switch (action.type) {
        case FETCH_CHACK_AI_IMAGE:
            state = action.data;
            return action.data;
        default:
            return state;
    }
}

export function checkAiInsdustryData(state = {}, action) {
    switch (action.type) {
        case FETCH_CHACK_AI_INSDUSTRY:
            state = action.data;
            return action.data;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/product.js